import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Endpoints} from "../../../api/endpoints";

@Injectable({providedIn: 'root'})
export class AppraiserLoadingService {
  private _urlMap: Map<string, boolean> = new Map<string, boolean>();

  /**
   * Constructor
   */
  constructor(private _endpoint: Endpoints) {
  }

  private _auto$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  /**
   * Getter for auto mode
   */
  get auto$(): Observable<boolean> {
    return this._auto$.asObservable();
  }

  private _mode$: BehaviorSubject<'determinate' | 'indeterminate'> = new BehaviorSubject<'determinate' | 'indeterminate'>('indeterminate');

  /**
   * Getter for mode
   */
  get mode$(): Observable<'determinate' | 'indeterminate'> {
    return this._mode$.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  private _progress$: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(0);

  /**
   * Getter for progress
   */
  get progress$(): Observable<any> {
    return this._progress$.asObservable();
  }

  private _show$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /**
   * Getter for show
   */
  get show$(): Observable<boolean> {
    return this._show$.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Show the loading bar
   */

  /*show(): void {
      this._show$.next(true);
  }

  /!**
   * Hide the loading bar
   *!/
  hide(): void {
      this._show$.next(false);
  }*/

  /**
   * Set the auto mode
   *
   * @param value
   */
  setAutoMode(value: boolean): void {
    this._auto$.next(value);
  }

  /**
   * Set the mode
   *
   * @param value
   */
  /*  setMode(value: 'determinate' | 'indeterminate'): void {
        this._mode$.next(value);
    }*/

  /**
   * Set the progress of the bar manually
   *
   * @param value
   */

  /*setProgress(value: number): void {
      if (value < 0 || value > 100) {
          console.error('Progress value must be between 0 and 100!');
          return;
      }

      this._progress$.next(value);
  }*/

  /**
   * Sets the loading status on the given url
   *
   * @param status
   * @param url
   */
  _setLoadingStatus(status: boolean, url: string): void {
    // Restrict Loader for Specific endpoints
    // || (url.includes(this._endpoint.utility_dropdown_settings))
    // (url.includes(this._endpoint.utility_profile_details_by_id)) ||
    if ( (!url.includes(this._endpoint.utility_pricing_plans) && (url.includes(this._endpoint.utility_dropdown)))) {
      return;
    }
    // Return if the url was not provided
    if (!url) {
      return;
    }

    if (status) {
      this._urlMap.set(url, status);
      this._show$.next(true);
    } else if (!status && this._urlMap.has(url)) {
      this._urlMap.delete(url);
    }

    // Only set the status to 'false' if all outgoing requests are completed
    if (this._urlMap.size === 0) {
      this._show$.next(false);
    }
  }
}
